const SvgIconAnonym = ({ fill, width = '24', height = '28', className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 56 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28.3334" cy="11.3334" r="11.3334" fill={fill} />
      <path
        d="M55.7529 49.8119C55.7529 46.1511 55.0319 42.5261 53.6309 39.144C52.23 35.7619 50.1766 32.6888 47.5881 30.1002C44.9995 27.5117 41.9264 25.4583 38.5443 24.0574C35.1622 22.6565 31.5372 21.9354 27.8764 21.9354C24.2157 21.9354 20.5907 22.6565 17.2086 24.0574C13.8265 25.4583 10.7534 27.5117 8.16482 30.1002C5.57625 32.6888 3.52289 35.7619 2.12197 39.144C0.721045 42.5261 -3.20036e-07 46.1511 0 49.8119L27.8765 49.8119H55.7529Z"
        fill={fill}
      />
    </svg>
  );
};
export default SvgIconAnonym;
